import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const PinSolid = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M9.5 14.5L3 21" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M5.00007 9.48528L14.1925 18.6777L15.8895 16.9806L15.4974 13.1944L21.0065 8.5211L15.1568 2.67141L10.4834 8.18034L6.69713 7.78823L5.00007 9.48528Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="hybrid">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { PinSolid };